const baseStyle = {};
const defaultProps = {};
const sizes = {};
export default {
  baseStyle,
  defaultProps,
  sizes,
};
